module.exports = __webpack_public_path__ + "static/media/btx.5fc7218f.svg";